import React from 'react'
import PropTypes from 'prop-types'

import { Menu } from 'semantic-ui-react'

const PaginationRow = ({ page, pages, pagesArray, setPage }) => (
  <Menu widths={pagesArray.length + 2} borderless>
    {page > 1 ? <Menu.Item icon="left chevron" onClick={() => setPage(page - 1)} /> : <Menu.Item icon="left chevron" active />}

    {pagesArray}

    {page < pages ? <Menu.Item icon="right chevron" onClick={() => setPage(page + 1)} /> : <Menu.Item active icon="right chevron" />}
  </Menu>
)

PaginationRow.propTypes = {
  page: PropTypes.number.isRequired,
  pages: PropTypes.number.isRequired,
  pagesArray: PropTypes.array.isRequired,
  setPage: PropTypes.func.isRequired,
}

export default PaginationRow
